import { createResource } from './create-request'

export const EmailReports = createResource('/api/email-reports')
